const defaultConfig = {
    "hood-base-color": "black",
    "crown-color": "black",
    "brow-color": "white",
    "bridge-color": "white",
    "nose-color": "black",
    "muzzle-color": "white",
    "muzzle-lip-color": "white",
    "chin-color": "black",
    "ear-a-color": "white",
    "ear-b-color": "black",
    "ear-c-color": "black",
    "muzzle-a-color": "white",
    "muzzle-b-color": "white",
    "whiskers-color": "white",
    "nose-patch-color": "white",
    "muzzle-button": "black",
    "bridge-button": "black",
    "muzzle-button-b": "black",
    "ear-button": "black",
    "muzzle-style": "default", // ["default", "fur", "style1", "style2", "added-default", "added-fur"]
    "muzzle-assoicate": "default", // ["default", "mustache", "fur"]
    "eyebrow-style": "default", // ["default", "dou", "frame"]
    "spikes-style": "default", // ["default", "spikes1", "spikes2"]
    "glass-hole": false,
    "ear-hole": false,
    "nose-patch": false,
    "black-type-light": true,
    "hood-size": "L"
};

const defaultBlackConfigLight = {
    "hood-base-color": true,
    "crown-color": true,
    "brow-color": true,
    "bridge-color": true,
    "nose-color": true,
    "muzzle-color": false,
    "muzzle-lip-color": true,
    "chin-color": true,
    "ear-a-color": false,
    "ear-b-color": true,
    "ear-c-color": true,
    "muzzle-a-color": true,
    "muzzle-b-color": true,
    "whiskers-color": true,
    "nose-patch-color": true,
    "muzzle-button": true,
    "bridge-button": true,
    "muzzle-button-b": true,
    "ear-button": true,
}

const defaultBlackConfigNonLight = {
    "hood-base-color": false,
    "crown-color": false,
    "brow-color": false,
    "bridge-color": false,
    "nose-color": false,
    "muzzle-color": false,
    "muzzle-lip-color": false,
    "chin-color": false,
    "ear-a-color": false,
    "ear-b-color": false,
    "ear-c-color": false,
    "muzzle-a-color": false,
    "muzzle-b-color": false,
    "whiskers-color": false,
    "nose-patch-color": false,
    "muzzle-button": false,
    "bridge-button": false,
    "muzzle-button-b": false,
    "ear-button": false,
}

const colorItems = [
    "hood-base-color",
    "crown-color",
    "brow-color",
    "bridge-color",
    "nose-color",
    "muzzle-color",
    "muzzle-lip-color",
    "chin-color",
    "ear-a-color",
    "ear-b-color",
    "ear-c-color",
    "muzzle-a-color",
    "muzzle-b-color",
    "muzzle-button",
    "bridge-button",
    "muzzle-button-b",
    "ear-button",
    "whiskers-color",
    "nose-patch-color"
];

const styleItems = [
    "muzzle-style",
    "muzzle-assoicate",
    "eyebrow-style",
    "spikes-style"
];

// nose-patch is encoded FIRST so it becomes the highest bit — older 3-bit check
// strings (glass-hole/ear-hole/black-type-light) still decode with nose-patch=false.
const checkItems = [
    "nose-patch",
    "glass-hole",
    "ear-hole",
    "black-type-light"
];

const revertCheckItems = [
    "black-type-light",
    "ear-hole",
    "glass-hole",
    "nose-patch"
];


const colorList = [
    "red",
    "orange",
    "yellow",
    "green",
    "tiffany",
    "light-blue",
    "blue",
    "brown",
    "pupple",
    "pink",
    "white",
    "gray",
    "black",
    "texture-black",
    "texture-1",
    "texture-2",
    "metal",
    "dark-green",
    "dark-blue",
    "dark-gray",
    "rose-red",
    "apricot",
    "lake-blue",
    "peach-red",
    "grass-green",
    "dark-chocolate"
];

// Buttons use their own dedicated color list (vibrant solids + metal + lake-blue).
const buttonColorList = [
    "red",
    "orange",
    "yellow",
    "green",
    "light-blue",
    "blue",
    "pupple",
    "pink",
    "white",
    "gray",
    "black",
    "metal",
    "lake-blue"
];

const styleList = [
    "default",
    "fur",
    "added-default",
    "added-fur",
    "mustache",
    "dou",
    "frame",
    "spikes1",
    "spikes2",
    "style1",
    "style2"
];

const sizeList = [
    "XXL",
    "XL",
    "L",
    "M"
]

function encodeColor(config) {
    let colorStr = ''
    colorItems.forEach((i) => {
        let r = colorList.indexOf(config[i]);
        if (r < 0) {
            r = 12;
            throw new Error('Unknown Color: ' + i + ' ' + config[i]);
        }
        colorStr += r.toString(32);
    })
    return colorStr;
}

function encodeStyle(config) {
    let styleStr = ''
    styleItems.forEach((i) => {
        let r = styleList.indexOf(config[i]);
        if (r < 0) {
            r = 0;
            throw new Error('Unknown Style: ' + i + ' '  + config[i]);
        }
        styleStr += r.toString(32);
    })
    return styleStr;
}

function encodeCheck(config) {
    let check = 0
    checkItems.forEach((i) => {
        check = check * 2 + (config[i] ? 1 : 0);
    })
    return check.toString(32);
}

function encode(config) {
    try {
        return (encodeColor(config) + "_" + encodeStyle(config) + "_" + encodeCheck(config) + "_" + ('hood-size' in config ? config['hood-size']: "L")).toUpperCase();
    } catch (error){
        console.log('错误', error);
        // alert('未知错误！');
    }
    
}

function decodeColor(str) {
    // back-compat: color keys were appended over time (muzzle-button-b, then
    // whiskers-color + nose-patch-color), so older codes are shorter. Pad by
    // repeating the last encoded color so old shareable links still decode.
    while (str.length < colorItems.length) {
        str = str + str[str.length - 1];
    }
    if (str.length !== colorItems.length) {
        return {}
    }
    let colorConfig = {}
    colorItems.forEach((k, i) => {
        const colorIndex = parseInt(str[i], 32);
        if (colorIndex < colorList.length) {
            colorConfig[k] = colorList[colorIndex];
        }
    })
    return colorConfig;
}

function decodeStyle(str) {
    if (str.length === styleItems.length - 1) {
        str = str + '0'
    }
    if (str.length !== styleItems.length) {
        return {}
    }
    let styleConfig = {}
    styleItems.forEach((k, i) => {
        const styleIndex = parseInt(str[i], 32);
        if (styleIndex < styleList.length) {
            styleConfig[k] = styleList[styleIndex];
        }
    })
    return styleConfig;
}

function decodeCheck(str) {
    let check = parseInt(str, 32);
    let checkConfig = {}
    revertCheckItems.forEach((k) => {
        checkConfig[k] = check % 2 === 1 ? true : false
        check = Math.floor(check / 2)
    });
    return checkConfig;
}

function decode(str) {
    try {
        let [colorStr, styleStr, checkStr, sizeStr] = str.split('_')
        if (!sizeList.includes(sizeStr)) {
            sizeStr = "L"
        }

        const colorConfig = decodeColor(colorStr);
        const styleConfig = decodeStyle(styleStr);
        const checkConfig = decodeCheck(checkStr);
        if (!colorConfig || !styleConfig || !checkConfig) {
            return defaultConfig;
        }
        const sizeConfig = {"hood-size": sizeStr}
        return {...colorConfig, ...styleConfig, ...checkConfig, ...sizeConfig};
    } catch (error) {
        console.log('错误', error);
        return defaultConfig;
    }
}

function encodeBlackConfig(blackConfig) {
    let blackStr = ''
    colorItems.forEach((i) => {
        let r = blackConfig[i] ? 1 : 0;
        blackStr += r.toString();
    })
    return blackStr;
}

function decodeBlackConfig(str) {
    if (!str) {
        return
    }   
    // back-compat: pad older (shorter) black_config strings by repeating the last bit
    while (str.length < colorItems.length) {
        str = str + str[str.length - 1];
    }
    if (str.length !== colorItems.length) {
        return
    }
    let blackConfig = {}
    colorItems.forEach((k, i) => {
        const blackIndex = parseInt(str[i]);
        if (blackIndex < 2) {
            blackConfig[k] = blackIndex === 1;
        }
    })
    return blackConfig;
}

module.exports = {
    encode,
    decode,
    encodeBlackConfig,
    decodeBlackConfig,
    colorList,
    buttonColorList,
    defaultConfig,
    defaultBlackConfigNonLight,
    defaultBlackConfigLight
};
